const ATTRIBUTE_GROUP_COLOR = 1;
const ATTRIBUTE_GROUP_VENDOR_SIZE = 2;
const ATTRIBUTE_GROUP_GENDERAGE = 3;
const ATTRIBUTE_GROUP_CUPSIZE = 4;
const ATTRIBUTE_GROUP_LENGTH = 5;
const ATTRIBUTE_GROUP_DIMENSION3 = 6;
const ATTRIBUTE_GROUP_BI_SIZE = 7;
const ATTRIBUTE_GROUP_SHOP_SIZE = 8;
const ATTRIBUTE_GROUP_CATEGORY_SHOP_FILTER_SIZES = 9;
const ATTRIBUTE_GROUP_SORT = 10;
const ATTRIBUTE_GROUP_SIZE_TRANSLATION_TYPE = 11;
const ATTRIBUTE_GROUP_SHOP_SIZE_RUN = 12;
const ATTRIBUTE_GROUP_SIZERUN = 172;
const ATTRIBUTE_GROUP_SIZECODE = 206;
const ATTRIBUTE_GROUP_COLOR_DETAIL = 210;
const ATTRIBUTE_GROUP_CHANNEL = 211;
const ATTRIBUTE_GROUP_CONDITION = 234;
const ATTRIBUTE_GROUP_CARESYMBOL = 247;
const ATTRIBUTE_GROUP_STYLETAGS_FEMALE = 254;
const ATTRIBUTE_GROUP_STYLETAGS_MALE = 255;
const ATTRIBUTE_GROUP_MATERIAL = 257;
const ATTRIBUTE_GROUP_BICOLOR = 258;
const ATTRIBUTE_GROUP_SHELL = 259;
const ATTRIBUTE_GROUP_LINING = 260;
const ATTRIBUTE_GROUP_WAREHOUSE_ID = 261;
const ATTRIBUTE_GROUP_NUMBER_OF_COMPONENTS = 262;
const ATTRIBUTE_GROUP_QUANTITY_PER_PACK = 263;
const ATTRIBUTE_GROUP_SMARTPHONES = 284;
const ATTRIBUTE_GROUP_TABLETS = 285;
const ATTRIBUTE_GROUP_LAPTOPS = 286;
const ATTRIBUTE_GROUP_RINGS_US = 287;
const ATTRIBUTE_GROUP_SEASON = 289;
const ATTRIBUTE_GROUP_PACKS_COLORWAY = 314;
const ATTRIBUTE_GROUP_PLUS_SIZE = 315;
const ATTRIBUTE_GROUP_MATERNITY = 316;
const ATTRIBUTE_GROUP_PATTERN = 317;
const ATTRIBUTE_GROUP_MATERIAL_STYLE = 318;
const ATTRIBUTE_GROUP_LACE = 319;
const ATTRIBUTE_GROUP_SLEEVE_LENGTH = 320;
const ATTRIBUTE_GROUP_STRAPS_STYLE = 321;
const ATTRIBUTE_GROUP_UPPER_LENGTH = 322;
const ATTRIBUTE_GROUP_NECKLINE_STYLE = 323;
const ATTRIBUTE_GROUP_SKIRT_STYLE = 324;
const ATTRIBUTE_GROUP_BOTTOM_LENGTH = 325;
const ATTRIBUTE_GROUP_TROUSERS_CUT = 326;
const ATTRIBUTE_GROUP_JEANS_FINISH = 327;
const ATTRIBUTE_GROUP_WAIST_HEIGHT = 328;
const ATTRIBUTE_GROUP_JACKET_STYLE = 329;
const ATTRIBUTE_GROUP_COAT_STYLE = 330;
const ATTRIBUTE_GROUP_SHIRT_CUT = 331;
const ATTRIBUTE_GROUP_SHIRT_COLLAR_STYLE = 332;
const ATTRIBUTE_GROUP_HEEL_HEIGHT = 333;
const ATTRIBUTE_GROUP_HEEL_TYPE = 334;
const ATTRIBUTE_GROUP_PLATFORM = 335;
const ATTRIBUTE_GROUP_TOECAP = 336;
const ATTRIBUTE_GROUP_SPORT_TYPE = 337;
const ATTRIBUTE_GROUP_BAG_SIZE = 338;
const ATTRIBUTE_GROUP_EARRING_STYLE = 339;
const ATTRIBUTE_GROUP_DETAILS = 359;
const ATTRIBUTE_GROUP_BUSINESS_SHOES = 360;
const ATTRIBUTE_GROUP_STRAP_LENGTH = 361;
const ATTRIBUTE_GROUP_NECKLACE_STYLE = 362;
const ATTRIBUTE_GROUP_CHRONOGRAPH = 363;
const ATTRIBUTE_GROUP_SIZE_ADVICE = 368;
const ATTRIBUTE_GROUP_TRENDSETTER = 443;
const ATTRIBUTE_GROUP_BUSINESS = 446;
const ATTRIBUTE_GROUP_FASHION_FACTOR = 449;
const ATTRIBUTE_GROUP_FASHION_STYLE = 450;
const ATTRIBUTE_GROUP_CONTAINS_NON_TEXTILE_PARTS_OF_ANIMAL_ORIGIN = 451;
const ATTRIBUTE_GROUP_SHOES_MEN_US_KED = 463;
const ATTRIBUTE_GROUP_ELASTICITY = 471;
const ATTRIBUTE_GROUP_PREMIUM = 472;
const ATTRIBUTE_GROUP_GROSS_MARGIN = 489;
const ATTRIBUTE_GROUP_BRA_STYLE = 527;
const ATTRIBUTE_GROUP_BRA_STRAPS_STYLE = 528;
const ATTRIBUTE_GROUP_BRA_WIRE = 529;
const ATTRIBUTE_GROUP_BRA_CUP = 530;
const ATTRIBUTE_GROUP_SPORT_WEIGHT = 531;
const ATTRIBUTE_GROUP_SPORT_FUNCTION_TEXTILES = 532;
const ATTRIBUTE_GROUP_SPORT_JERSEY = 533;
const ATTRIBUTE_GROUP_SPORT_MEMBRAN_TECHNOLOGY = 534;
const ATTRIBUTE_GROUP_SPORT_JACKET_STYLE = 535;
const ATTRIBUTE_GROUP_SPORT_JACKET_DETAIL = 536;
const ATTRIBUTE_GROUP_SPORT_TROUSERS_DETAIL = 537;
const ATTRIBUTE_GROUP_SPORT_SHOE_FUNCTION = 538;
const ATTRIBUTE_GROUP_SPORT_SOLE = 539;
const ATTRIBUTE_GROUP_SPORT_INSOLE = 540;
const ATTRIBUTE_GROUP_SPORT_PRONATION = 541;
const ATTRIBUTE_GROUP_SPORT_HEEL_GRADIENT = 542;
const ATTRIBUTE_GROUP_SPORT_FOOTBALL_SHOES = 543;
const ATTRIBUTE_GROUP_SPORT_OUTDOOR_SHOES = 544;
const ATTRIBUTE_GROUP_SPORT_GUARD_TYPE = 545;
const ATTRIBUTE_GROUP_SPORT_RACKET_TYPE = 546;
const ATTRIBUTE_GROUP_SPORT_RACKET_STRINGS = 547;
const ATTRIBUTE_GROUP_SPORT_BALL = 548;
const ATTRIBUTE_GROUP_BRAND = 550;
const ATTRIBUTE_GROUP_CATEGORY = 551;
const ATTRIBUTE_GROUP_SNEAKER_STYLE = 563;
const ATTRIBUTE_GROUP_CHAIN_FOLLOWER = 564;
const ATTRIBUTE_GROUP_BLOUSE_STYLE = 1132;
const ATTRIBUTE_GROUP_SCARF_SHAPE = 1133;
const ATTRIBUTE_GROUP_TRAVEL_BAG_STYLE = 1134;
const ATTRIBUTE_GROUP_HEADPHONE_TYPE = 1135;
const ATTRIBUTE_GROUP_SPORT_SOLE_TYPE = 1136;
const ATTRIBUTE_GROUP_SPORT_HOOD_DETAILS = 1137;
const ATTRIBUTE_GROUP_LINING_TYPE = 1138;
const ATTRIBUTE_GROUP_SPORT_OUTDOOR_TECHNOLOGY = 1140;
const ATTRIBUTE_GROUP_SPORT_INSULATION = 1141;
const ATTRIBUTE_GROUP_FITTING = 1142;
const ATTRIBUTE_GROUP_BED_LINEN_MATERIAL_TYPE = 1143;
const ATTRIBUTE_GROUP_JEWELLERY_MATERIAL_STYLE = 1144;
const ATTRIBUTE_GROUP_TOWEL_MATERIAL_TYPE = 1145;
const ATTRIBUTE_GROUP_SHOE_MATERIAL_STYLE = 1146;
const ATTRIBUTE_GROUP_KNIT_MATERIAL_TYPE = 1147;
const ATTRIBUTE_GROUP_BASIC = 1148;
const ATTRIBUTE_GROUP_DESSOUS = 1149;
const ATTRIBUTE_GROUP_JEWELLERY_TYPE = 1150;
const ATTRIBUTE_GROUP_SPORT_FAN_ARTICLE = 1151;
const ATTRIBUTE_GROUP_TARGET_GROUP = 1152;
const ATTRIBUTE_GROUP_TRADITIONAL_BAVARIAN = 1153;
const ATTRIBUTE_GROUP_SPECIAL_SIZES = 1571;
const ATTRIBUTE_GROUP_GENDER_CATEGORY = 1621;
const ATTRIBUTE_GROUP_FASTENER_TYPE = 1469;
const ATTRIBUTE_GROUP_MERCHANT_NAME = 1625;

const ATTRIBUTE_GROUP_NAMES = {
  [ATTRIBUTE_GROUP_COLOR]: 'color',
  [ATTRIBUTE_GROUP_VENDOR_SIZE]: 'vendorSize',
  [ATTRIBUTE_GROUP_GENDERAGE]: 'genderage',
  [ATTRIBUTE_GROUP_CUPSIZE]: 'cupsize',
  [ATTRIBUTE_GROUP_LENGTH]: 'length',
  [ATTRIBUTE_GROUP_DIMENSION3]: 'dimension3',
  [ATTRIBUTE_GROUP_BI_SIZE]: 'biSize',
  [ATTRIBUTE_GROUP_SHOP_SIZE]: 'shopSize',
  [ATTRIBUTE_GROUP_CATEGORY_SHOP_FILTER_SIZES]: 'categoryShopFilterSizes',
  [ATTRIBUTE_GROUP_SORT]: 'sort',
  [ATTRIBUTE_GROUP_SIZE_TRANSLATION_TYPE]: 'sizeTranslationType',
  [ATTRIBUTE_GROUP_SHOP_SIZE_RUN]: 'shopSizeRun',
  [ATTRIBUTE_GROUP_SIZERUN]: 'sizeRun',
  [ATTRIBUTE_GROUP_SIZECODE]: 'sizeCode',
  [ATTRIBUTE_GROUP_COLOR_DETAIL]: 'colorDetail',
  [ATTRIBUTE_GROUP_CHANNEL]: 'channel',
  [ATTRIBUTE_GROUP_CONDITION]: 'condition',
  [ATTRIBUTE_GROUP_CARESYMBOL]: 'careSymbol',
  [ATTRIBUTE_GROUP_STYLETAGS_FEMALE]: 'styleTagsFemale',
  [ATTRIBUTE_GROUP_STYLETAGS_MALE]: 'styleTagsMale',
  [ATTRIBUTE_GROUP_MATERIAL]: 'material',
  [ATTRIBUTE_GROUP_BICOLOR]: 'biColor',
  [ATTRIBUTE_GROUP_SHELL]: 'shell',
  [ATTRIBUTE_GROUP_LINING]: 'lining',
  [ATTRIBUTE_GROUP_WAREHOUSE_ID]: 'warehouseId',
  [ATTRIBUTE_GROUP_NUMBER_OF_COMPONENTS]: 'numberOfComponents',
  [ATTRIBUTE_GROUP_QUANTITY_PER_PACK]: 'quantityPerPack',
  [ATTRIBUTE_GROUP_SMARTPHONES]: 'smartphones',
  [ATTRIBUTE_GROUP_TABLETS]: 'tablets',
  [ATTRIBUTE_GROUP_LAPTOPS]: 'laptops',
  [ATTRIBUTE_GROUP_RINGS_US]: 'ringsUs',
  [ATTRIBUTE_GROUP_SEASON]: 'season',
  [ATTRIBUTE_GROUP_PACKS_COLORWAY]: 'packsColorway',
  [ATTRIBUTE_GROUP_PLUS_SIZE]: 'plusSize',
  [ATTRIBUTE_GROUP_MATERNITY]: 'maternity',
  [ATTRIBUTE_GROUP_PATTERN]: 'pattern',
  [ATTRIBUTE_GROUP_MATERIAL_STYLE]: 'materialStyle',
  [ATTRIBUTE_GROUP_LACE]: 'lace',
  [ATTRIBUTE_GROUP_SLEEVE_LENGTH]: 'sleeveLength',
  [ATTRIBUTE_GROUP_STRAPS_STYLE]: 'strapsStyle',
  [ATTRIBUTE_GROUP_UPPER_LENGTH]: 'upperLength',
  [ATTRIBUTE_GROUP_NECKLINE_STYLE]: 'necklineStyle',
  [ATTRIBUTE_GROUP_SKIRT_STYLE]: 'skirtStyle',
  [ATTRIBUTE_GROUP_BOTTOM_LENGTH]: 'bottomLength',
  [ATTRIBUTE_GROUP_TROUSERS_CUT]: 'trousersCut',
  [ATTRIBUTE_GROUP_JEANS_FINISH]: 'jeansFinish',
  [ATTRIBUTE_GROUP_WAIST_HEIGHT]: 'waistHeight',
  [ATTRIBUTE_GROUP_JACKET_STYLE]: 'jacketStyle',
  [ATTRIBUTE_GROUP_COAT_STYLE]: 'coatStyle',
  [ATTRIBUTE_GROUP_SHIRT_CUT]: 'shirtCut',
  [ATTRIBUTE_GROUP_SHIRT_COLLAR_STYLE]: 'shirtCollarStyle',
  [ATTRIBUTE_GROUP_HEEL_HEIGHT]: 'heelHeight',
  [ATTRIBUTE_GROUP_HEEL_TYPE]: 'heelType',
  [ATTRIBUTE_GROUP_PLATFORM]: 'platform',
  [ATTRIBUTE_GROUP_TOECAP]: 'toecap',
  [ATTRIBUTE_GROUP_SPORT_TYPE]: 'sportType',
  [ATTRIBUTE_GROUP_BAG_SIZE]: 'bagSize',
  [ATTRIBUTE_GROUP_EARRING_STYLE]: 'earringStyle',
  [ATTRIBUTE_GROUP_DETAILS]: 'details',
  [ATTRIBUTE_GROUP_BUSINESS_SHOES]: 'businessShoes',
  [ATTRIBUTE_GROUP_STRAP_LENGTH]: 'strapLength',
  [ATTRIBUTE_GROUP_NECKLACE_STYLE]: 'necklaceStyle',
  [ATTRIBUTE_GROUP_CHRONOGRAPH]: 'chronograph',
  [ATTRIBUTE_GROUP_SIZE_ADVICE]: 'sizeAdvice',
  [ATTRIBUTE_GROUP_TRENDSETTER]: 'trendsetter',
  [ATTRIBUTE_GROUP_BUSINESS]: 'business',
  [ATTRIBUTE_GROUP_FASHION_FACTOR]: 'fashionFactor',
  [ATTRIBUTE_GROUP_FASHION_STYLE]: 'fashionStyle',
  [ATTRIBUTE_GROUP_CONTAINS_NON_TEXTILE_PARTS_OF_ANIMAL_ORIGIN]:
    'containsNonTextilePartsOfAnimalOrigin',
  [ATTRIBUTE_GROUP_SHOES_MEN_US_KED]: 'shoesMensUsKeds',
  [ATTRIBUTE_GROUP_ELASTICITY]: 'elasticity',
  [ATTRIBUTE_GROUP_PREMIUM]: 'premium',
  [ATTRIBUTE_GROUP_GROSS_MARGIN]: 'grossMargin',
  [ATTRIBUTE_GROUP_BRA_STYLE]: 'braStyle',
  [ATTRIBUTE_GROUP_BRA_STRAPS_STYLE]: 'braStrapsStyle',
  [ATTRIBUTE_GROUP_BRA_WIRE]: 'braWire',
  [ATTRIBUTE_GROUP_BRA_CUP]: 'braCup',
  [ATTRIBUTE_GROUP_SPORT_WEIGHT]: 'sportWeight',
  [ATTRIBUTE_GROUP_SPORT_FUNCTION_TEXTILES]: 'sportFunctionTextiles',
  [ATTRIBUTE_GROUP_SPORT_JERSEY]: 'sportJersey',
  [ATTRIBUTE_GROUP_SPORT_MEMBRAN_TECHNOLOGY]: 'sportMembranTechnology',
  [ATTRIBUTE_GROUP_SPORT_JACKET_STYLE]: 'sportJacketStyle',
  [ATTRIBUTE_GROUP_SPORT_JACKET_DETAIL]: 'sportJacketDetail',
  [ATTRIBUTE_GROUP_SPORT_TROUSERS_DETAIL]: 'sportTrousersDetail',
  [ATTRIBUTE_GROUP_SPORT_SHOE_FUNCTION]: 'sportShoeFunction',
  [ATTRIBUTE_GROUP_SPORT_SOLE]: 'sportSole',
  [ATTRIBUTE_GROUP_SPORT_INSOLE]: 'sportInsole',
  [ATTRIBUTE_GROUP_SPORT_PRONATION]: 'sportPronation',
  [ATTRIBUTE_GROUP_SPORT_HEEL_GRADIENT]: 'sportHeelGradient',
  [ATTRIBUTE_GROUP_SPORT_FOOTBALL_SHOES]: 'sportFootballShoes',
  [ATTRIBUTE_GROUP_SPORT_OUTDOOR_SHOES]: 'sportOutdoorShoes',
  [ATTRIBUTE_GROUP_SPORT_GUARD_TYPE]: 'sportGuardType',
  [ATTRIBUTE_GROUP_SPORT_RACKET_TYPE]: 'sportRacketType',
  [ATTRIBUTE_GROUP_SPORT_RACKET_STRINGS]: 'sportRacketStrings',
  [ATTRIBUTE_GROUP_SPORT_BALL]: 'sportBall',
  [ATTRIBUTE_GROUP_BRAND]: 'brand',
  [ATTRIBUTE_GROUP_CATEGORY]: 'category',
  [ATTRIBUTE_GROUP_SNEAKER_STYLE]: 'sneakerStyle',
  [ATTRIBUTE_GROUP_CHAIN_FOLLOWER]: 'chainFollower',
  [ATTRIBUTE_GROUP_BLOUSE_STYLE]: 'blouseStyle',
  [ATTRIBUTE_GROUP_SCARF_SHAPE]: 'scarfShape',
  [ATTRIBUTE_GROUP_TRAVEL_BAG_STYLE]: 'travelBagStyle',
  [ATTRIBUTE_GROUP_HEADPHONE_TYPE]: 'headphoneType',
  [ATTRIBUTE_GROUP_SPORT_SOLE_TYPE]: 'sportSoleType',
  [ATTRIBUTE_GROUP_SPORT_HOOD_DETAILS]: 'sportHoodDetails',
  [ATTRIBUTE_GROUP_LINING_TYPE]: 'liningType',
  [ATTRIBUTE_GROUP_SPORT_OUTDOOR_TECHNOLOGY]: 'sportOutdoorTechnology',
  [ATTRIBUTE_GROUP_SPORT_INSULATION]: 'sportInsulation',
  [ATTRIBUTE_GROUP_FITTING]: 'fitting',
  [ATTRIBUTE_GROUP_BED_LINEN_MATERIAL_TYPE]: 'bedLinenMaterialType',
  [ATTRIBUTE_GROUP_JEWELLERY_MATERIAL_STYLE]: 'jewelleryMaterialStyle',
  [ATTRIBUTE_GROUP_TOWEL_MATERIAL_TYPE]: 'towelMaterialType',
  [ATTRIBUTE_GROUP_SHOE_MATERIAL_STYLE]: 'shoeMaterialStyle',
  [ATTRIBUTE_GROUP_KNIT_MATERIAL_TYPE]: 'knitMaterialType',
  [ATTRIBUTE_GROUP_BASIC]: 'basic',
  [ATTRIBUTE_GROUP_DESSOUS]: 'dessous',
  [ATTRIBUTE_GROUP_JEWELLERY_TYPE]: 'jewelleryType',
  [ATTRIBUTE_GROUP_SPORT_FAN_ARTICLE]: 'sportFanArticle',
  [ATTRIBUTE_GROUP_TARGET_GROUP]: 'targetGroup',
  [ATTRIBUTE_GROUP_TRADITIONAL_BAVARIAN]: 'traditionalBavarian',
  [ATTRIBUTE_GROUP_SPECIAL_SIZES]: 'specialSizesFilter',
  [ATTRIBUTE_GROUP_GENDER_CATEGORY]: 'genderCategory',
  [ATTRIBUTE_GROUP_FASTENER_TYPE]: 'fastenerType',
  [ATTRIBUTE_GROUP_MERCHANT_NAME]: 'merchantName',
};

export function getAttributeGroupName(attributeGroupId: number) {
  return (
    ATTRIBUTE_GROUP_NAMES[attributeGroupId] &&
    ATTRIBUTE_GROUP_NAMES[attributeGroupId]
  );
}



// WEBPACK FOOTER //
// ./src/utils/attributes.ts